import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Button from 'ui/Button';
import Icon from 'ui/Icon';
import Tooltip from 'ui/Tooltip';

import { pulseAnimation } from '../../../constants';

const SaveButton: React.FC = () => {
  const { openConversionModal, isAuthOrConversionModalOpen } =
    useGlobalModalsContext();

  return (
    <Tooltip content="Subscribe to save your changes in the cloud and access your diagram from anywhere, anytime.">
      <Button
        animation={
          !isAuthOrConversionModalOpen
            ? `${pulseAnimation} 5s infinite`
            : undefined
        }
        flexShrink={0}
        onClick={() => openConversionModal('Saving')}
        variant="primary-solid"
        size="sm"
      >
        Save changes <Icon icon="crown" />
      </Button>
    </Tooltip>
  );
};

export default SaveButton;
